import React, { useState } from "react";
import "./Profile.css";
import { UserProfile, ProfileTap, HotelsTab, ServicesTab, FlightsTab,PaymentTab, Filters } from "../../Features/Profile/index";
import { useTranslation } from "../../contexts/TranslationContext";
import { Button, Offcanvas } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import TabIcon from '../../assets/images/packages/svg/tabs.svg'

const Profile = ({ url }) => {
  const [activeTab, setActiveTab] = useState("profile");
  const [showDrawer, setShowDrawer] = useState(false);
  const { t } = useTranslation();

    const handleClose = () => setShowDrawer(false);
  const handleShow = () => setShowDrawer(true);

  const profileIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4754 10.9432C3.25238 10.9432 0.5 11.4305 0.5 13.3821C0.5 15.3337 3.23492 15.8384 6.4754 15.8384C9.69841 15.8384 12.45 15.3503 12.45 13.3995C12.45 11.4487 9.71587 10.9432 6.4754 10.9432Z"
        fill="#27346A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4754 8.15952C8.59048 8.15952 10.3048 6.44444 10.3048 4.32937C10.3048 2.21429 8.59048 0.5 6.4754 0.5C4.36032 0.5 2.64524 2.21429 2.64524 4.32937C2.6381 6.4373 4.34127 8.15238 6.44842 8.15952H6.4754Z"
        fill="#27346A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  
  const hotelsIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <path
        d="M3.75855 19.7324C3.24175 19.7324 2.79949 19.5485 2.43178 19.1808C2.06407 18.8131 1.8799 18.3705 1.87927 17.8531V7.5171C1.87927 7.0003 2.06344 6.55804 2.43178 6.19033C2.80012 5.82262 3.24237 5.63845 3.75855 5.63782H7.5171V3.75855C7.5171 3.24175 7.70127 2.79949 8.06961 2.43178C8.43794 2.06407 8.8802 1.8799 9.39637 1.87927H13.1549C13.6717 1.87927 14.1143 2.06344 14.4826 2.43178C14.851 2.80012 15.0348 3.24237 15.0342 3.75855V5.63782H18.7928C19.3096 5.63782 19.7521 5.82199 20.1205 6.19033C20.4888 6.55867 20.6727 7.00092 20.672 7.5171V17.8531C20.672 18.3699 20.4882 18.8125 20.1205 19.1808C19.7527 19.5492 19.3102 19.733 18.7928 19.7324H3.75855ZM9.39637 5.63782H13.1549V3.75855H9.39637V5.63782ZM5.63782 7.5171H3.75855V17.8531H5.63782V7.5171ZM15.0342 17.8531V7.5171H7.5171V17.8531H15.0342ZM16.9135 7.5171V17.8531H18.7928V7.5171H16.9135Z"
        fill="#27346A"
      />
    </svg>
  );
  
  const flightsIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <path
        d="M2.33536 19.6881H22.6644V21H2.33536V19.6881ZM20.9571 6.90346C19.9666 6.63635 18.9135 6.6553 17.9921 6.95675L17.9543 6.96905L15.1971 8.23753L7.15102 5.14104C6.79977 5.00443 6.41595 4.96606 6.04328 5.0303C5.6706 5.09453 5.32405 5.25879 5.0431 5.50436L3.96592 6.43903C3.85228 6.53765 3.76305 6.65978 3.70483 6.79635C3.64662 6.93292 3.62092 7.08042 3.62965 7.22792C3.63837 7.37542 3.6813 7.51912 3.75524 7.64836C3.82918 7.7776 3.93224 7.88907 4.05676 7.97448L9.04446 11.3961L7.13128 12.3662L5.61613 11.0261C5.32643 10.7704 4.96662 10.6011 4.57992 10.5386C4.19323 10.476 3.7961 10.5229 3.43626 10.6735L2.6123 11.0194C2.48352 11.0734 2.36769 11.1526 2.27211 11.2521C2.17653 11.3516 2.10327 11.4692 2.05695 11.5975C2.01063 11.7257 1.99225 11.8619 2.00297 11.9973C2.01369 12.1328 2.05328 12.2647 2.11924 12.3846L5.20337 17.9942L21.9995 9.98018C23.0052 9.52195 23.1278 8.7894 22.9066 8.25585C22.6615 7.66433 21.9508 7.17142 20.9571 6.90346ZM21.4188 8.79481L21.4124 8.79768L5.78257 16.2552L3.4881 12.0816L3.97515 11.8772C4.0951 11.8269 4.22748 11.8113 4.35639 11.8321C4.48529 11.853 4.60523 11.9094 4.70179 11.9947L6.91833 13.9552L11.6334 11.5643L5.18659 7.14165L5.94771 6.48126C6.04136 6.39942 6.15688 6.34468 6.28109 6.32327C6.40531 6.30185 6.53325 6.31463 6.65033 6.36015L15.2454 9.6679L18.4621 8.18808C19.1167 7.98272 19.8962 7.97633 20.6077 8.17115C21.1936 8.33162 21.5048 8.56473 21.6103 8.68699C21.5507 8.72956 21.4865 8.76575 21.4188 8.79493L21.4188 8.79481Z"
        fill="#27346A"
      />
    </svg>
  );
  
  const servicesIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M11.23 0V0.87875C10.7173 0.965882 10.2306 1.16615 9.805 1.465L9.16 0.85875L8.30062 1.7775L8.92562 2.36313C8.64041 2.78019 8.44718 3.25316 8.35875 3.75063H7.48V5.00063H8.35875C8.45 5.51938 8.655 5.99188 8.945 6.40688L8.28063 7.05062L9.18063 7.95062L9.82438 7.28562C10.2394 7.57562 10.7119 7.78063 11.2306 7.87188V8.75H12.4806V7.87125C12.978 7.78301 13.451 7.58999 13.8681 7.305L14.4531 7.93L15.3719 7.07L14.7656 6.42625C15.0594 6.0075 15.2594 5.52313 15.3519 5H16.23V3.75H15.3512C15.2615 3.24389 15.0613 2.76376 14.765 2.34375L15.3512 1.7575L14.4719 0.87875L13.8863 1.465C13.4662 1.16869 12.9861 0.968534 12.48 0.87875V0H11.23ZM11.855 2.07063C12.1582 2.06863 12.4588 2.12687 12.7393 2.24197C13.0198 2.35706 13.2747 2.52671 13.4891 2.74108C13.7035 2.95545 13.8733 3.21027 13.9884 3.49075C14.1036 3.77124 14.1619 4.0718 14.16 4.375C14.16 5.65938 13.1394 6.68 11.855 6.68C10.5706 6.68 9.55 5.65938 9.55 4.375C9.55 3.09063 10.5706 2.07 11.855 2.07V2.07063ZM3.74875 5.76125L2.5975 6.23L3.04625 7.36125C2.44893 7.71879 1.94645 8.21484 1.58125 8.8075L0.46875 8.3575L0 9.51062L1.1125 9.95937C1.02472 10.2975 0.978962 10.6451 0.97625 10.9944C0.97625 11.3506 1.02937 11.6981 1.1125 12.0294L0 12.4794L0.46875 13.6312L1.58125 13.1812C1.9432 13.7816 2.44605 14.2847 3.04625 14.6469L2.59625 15.7594L3.74938 16.2281L4.19938 15.1156C4.53747 15.2034 4.88509 15.2492 5.23438 15.2519C5.59062 15.2519 5.93937 15.1987 6.26937 15.1156L6.71937 16.2281L7.87125 15.7594L7.42125 14.6469C8.01453 14.2825 8.51075 13.7798 8.8675 13.1819L9.99875 13.6306L10.4675 12.4788L9.33625 12.0288C9.4175 11.6975 9.4725 11.3494 9.4725 10.9937C9.4725 10.6375 9.41813 10.2888 9.335 9.95813L10.4681 9.50937L9.99938 8.35625L8.86813 8.80625C8.50899 8.21517 8.01296 7.71913 7.42188 7.36L7.87188 6.22875L6.71875 5.76L6.27062 6.89125C5.93207 6.80485 5.58439 6.75932 5.235 6.75562C4.87875 6.75563 4.53125 6.80938 4.2 6.89188L3.75 5.76062L3.74875 5.76125ZM5.23375 8.00625C6.89813 8.00625 8.22125 9.33125 8.22125 10.995C8.2225 12.6594 6.89813 14.0025 5.23375 14.0025C4.83866 14.003 4.44736 13.9255 4.08225 13.7746C3.71714 13.6236 3.3854 13.4021 3.10603 13.1227C2.82666 12.8434 2.60514 12.5116 2.45418 12.1465C2.30321 11.7814 2.22576 11.3901 2.22625 10.995C2.22625 9.33062 3.57 8.00625 5.23375 8.00625Z"
        fill="#27346A"
      />
    </svg>
  );

  const paymentIcon = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.83301 4.125H8.02692C8.38819 4.12496 8.74591 4.19609 9.07967 4.33435C9.41343 4.4726 9.71668 4.67526 9.97209 4.93075L12.833 7.79167M4.58301 12.375H1.83301M7.79134 6.875L9.62467 8.70833C9.74505 8.82871 9.84054 8.97162 9.90569 9.1289C9.97084 9.28619 10.0044 9.45476 10.0044 9.625C10.0044 9.79524 9.97084 9.96381 9.90569 10.1211C9.84054 10.2784 9.74505 10.4213 9.62467 10.5417C9.5043 10.662 9.36139 10.7575 9.2041 10.8227C9.04682 10.8878 8.87825 10.9214 8.70801 10.9214C8.53777 10.9214 8.36919 10.8878 8.21191 10.8227C8.05463 10.7575 7.91172 10.662 7.79134 10.5417L6.41634 9.16667C5.62801 9.955 4.37859 10.0439 3.48576 9.37475L3.20801 9.16667" stroke="#27346A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4.58301 10.0834V14.2084C4.58301 15.9372 4.58301 16.8007 5.12017 17.3379C5.65734 17.875 6.52084 17.875 8.24967 17.875H16.4997C18.2285 17.875 19.092 17.875 19.6292 17.3379C20.1663 16.8007 20.1663 15.9372 20.1663 14.2084V11.4584C20.1663 9.72952 20.1663 8.86602 19.6292 8.32885C19.092 7.79169 18.2285 7.79169 16.4997 7.79169H8.70801" stroke="#27346A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.9788 12.8334C13.9788 13.2588 13.8098 13.6668 13.509 13.9677C13.2082 14.2685 12.8001 14.4375 12.3747 14.4375C11.9492 14.4375 11.5412 14.2685 11.2404 13.9677C10.9395 13.6668 10.7705 13.2588 10.7705 12.8334C10.7705 12.4079 10.9395 11.9999 11.2404 11.699C11.5412 11.3982 11.9492 11.2292 12.3747 11.2292C12.8001 11.2292 13.2082 11.3982 13.509 11.699C13.8098 11.9999 13.9788 12.4079 13.9788 12.8334Z" stroke="#27346A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )


  // Function to render the appropriate component based on active tab
  const renderContent = () => {
    switch (activeTab) {
      case "profile":
        return <UserProfile url={url} />;
      case "hotels":
        return <HotelsTab />;
      case "flights":
        return <FlightsTab />;
      case "services":
        return <ServicesTab />;
      case "payment":
        return <PaymentTab />;
      default:
        return <UserProfile url={url} />;
    }
  };

  return (
    // <div className="container">
    //   <div className="profile-container">
    //     <div className="profile-tabs-container">
    //       <ProfileTap
    //         text={t("MakeChangesAccount")}
    //         title={t("MyProfile")}
    //         svg={profileIcon}
    //         isActive={activeTab === "profile"}
    //         onClick={() => setActiveTab("profile")}
    //       />
    //       <ProfileTap
    //         text={t("MakeChangesAccount")}
    //         title={t("yourHotelsBookings")}
    //         svg={hotelsIcon}
    //         isActive={activeTab === "hotels"}
    //         onClick={() => setActiveTab("hotels")}
    //       />
    //       <ProfileTap
    //         text={t("MakeChangesAccount")}
    //         title={t("yourFlightsBookings")}
    //         svg={flightsIcon}
    //         isActive={activeTab === "flights"}
    //         onClick={() => setActiveTab("flights")}
    //       />
    //       <ProfileTap
    //         text={t("MakeChangesAccount")}
    //         title={t("yourServices")}
    //         svg={servicesIcon}
    //         isActive={activeTab === "services"}
    //         onClick={() => setActiveTab("services")}
    //       />
    //       <ProfileTap
    //         text={t("MakeChangesAccount")}
    //         title={t("PaymentHistory")}
    //         svg={paymentIcon}
    //         isActive={activeTab === "payment"}
    //         onClick={() => setActiveTab("payment")}
    //       />
    //     </div>
    //     <div className="profile-page-content-container">
    //       <div className="profile-page-content">
    //         {
    //           activeTab !== "profile" && (
    //             <Filters />
    //           )
    //         }
            
    //         {renderContent()}
    //       </div>
    //     </div>
    //   </div>
    // </div>
<div className="container profile-page">
      <div className="profile-tab-button" onClick={handleShow}>
        <img src={TabIcon}></img>
        <span>{t("ProfileTabs")}</span>
      </div>

      <Offcanvas show={showDrawer} onHide={handleClose} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="profile-tabs">{t("ProfileTabs")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ProfileTap text={t("MakeChangesAccount")} title={t("MyProfile")} svg={profileIcon} isActive={activeTab === "profile"} onClick={() => { setActiveTab("profile"); handleClose(); }} />
          <ProfileTap text={t("MakeChangesAccount")} title={t("yourHotelsBookings")} svg={hotelsIcon} isActive={activeTab === "hotels"} onClick={() => { setActiveTab("hotels"); handleClose(); }} />
          <ProfileTap text={t("MakeChangesAccount")} title={t("yourFlightsBookings")} svg={flightsIcon} isActive={activeTab === "flights"} onClick={() => { setActiveTab("flights"); handleClose(); }} />
          <ProfileTap text={t("MakeChangesAccount")} title={t("yourServices")} svg={servicesIcon} isActive={activeTab === "services"} onClick={() => { setActiveTab("services"); handleClose(); }} />
          <ProfileTap text={t("MakeChangesAccount")} title={t("PaymentHistory")} svg={paymentIcon} isActive={activeTab === "payment"} onClick={() => { setActiveTab("payment"); handleClose(); }} />
        </Offcanvas.Body>
      </Offcanvas>

      <div className="profile-container">
        <div className="profile-tabs-container d-none d-lg-flex">
          <ProfileTap text={t("MakeChangesAccount")} title={t("MyProfile")} svg={profileIcon} isActive={activeTab === "profile"} onClick={() => setActiveTab("profile")} />
          <ProfileTap text={t("MakeChangesAccount")} title={t("yourHotelsBookings")} svg={hotelsIcon} isActive={activeTab === "hotels"} onClick={() => setActiveTab("hotels")} />
          <ProfileTap text={t("MakeChangesAccount")} title={t("yourFlightsBookings")} svg={flightsIcon} isActive={activeTab === "flights"} onClick={() => setActiveTab("flights")} />
          <ProfileTap text={t("MakeChangesAccount")} title={t("yourServices")} svg={servicesIcon} isActive={activeTab === "services"} onClick={() => setActiveTab("services")} />
          <ProfileTap text={t("MakeChangesAccount")} title={t("PaymentHistory")} svg={paymentIcon} isActive={activeTab === "payment"} onClick={() => setActiveTab("payment")} />
        </div>

        <div className="profile-page-content-container">
          <div className="profile-page-content">
            {activeTab !== "profile" && <Filters />}
            {renderContent()}
          </div>
        </div>
      </div>
    </div>

  );
};

export default Profile;